import api from '@/config/api'
import type { ApiResponse } from '@/shared/types/api'
import type {
  CalendrierEtudiantDto,
  PeriodeEtudiantDto,
  DatesPeriodeEtudiantDto,
  CreateCalendrierEtudiantRequest,
  UpdateCalendrierEtudiantRequest,
  CreateDatesPeriodeEtudiantRequest,
} from '@/shared/types/calendrier'

export const calendrierApi = {
  // ── Calendrier ─────────────────────────────────────────

  getByEtudiantId: (etudiantId: number) =>
    api
      .get<ApiResponse<CalendrierEtudiantDto[]>>(`/api/calendrier-etudiant/etudiant/${etudiantId}`)
      .then((r) => r.data.data),

  getById: (id: number) =>
    api
      .get<ApiResponse<CalendrierEtudiantDto>>(`/api/calendrier-etudiant/${id}`)
      .then((r) => r.data.data),

  create: (data: CreateCalendrierEtudiantRequest) =>
    api
      .post<ApiResponse<CalendrierEtudiantDto>>('/api/calendrier-etudiant', data)
      .then((r) => r.data.data),

  update: (id: number, data: UpdateCalendrierEtudiantRequest) =>
    api
      .put<ApiResponse<CalendrierEtudiantDto>>(`/api/calendrier-etudiant/${id}`, data)
      .then((r) => r.data.data),

  delete: (id: number) =>
    api.delete(`/api/calendrier-etudiant/${id}`),

  // ── Périodes étudiant ──────────────────────────────────

  getPeriodesByEtudiantId: (etudiantId: number) =>
    api
      .get<ApiResponse<PeriodeEtudiantDto[]>>(`/api/periodes-etudiant/etudiant/${etudiantId}`)
      .then((r) => r.data.data),

  // ── Dates période étudiant ─────────────────────────────

  getDatesByCalendrierId: (calendrierId: number) =>
    api
      .get<ApiResponse<DatesPeriodeEtudiantDto[]>>(
        `/api/dates-periode-etudiant/calendrier/${calendrierId}`,
      )
      .then((r) => r.data.data),

  createDatePeriode: (data: CreateDatesPeriodeEtudiantRequest) =>
    api
      .post<ApiResponse<DatesPeriodeEtudiantDto>>('/api/dates-periode-etudiant', data)
      .then((r) => r.data.data),

  deleteDatePeriode: (id: number) =>
    api.delete(`/api/dates-periode-etudiant/${id}`),
}
